import {
    Claim,
    ClaimedOrderResponse,
    CoreClaimsGridOutput,
    GridOutput,
    ReceivedClaimedOrderPayload,
    CoreOrder,
    ProductInterface,
    GridInput,
    CoreGridInput,
} from 'skladon-types';

import { ClaimsMapper } from '../ClaimsMapper';
import { toNumber } from '../numbers';
import { asInt } from './coerceNumbers';

type ClaimV21Response = Omit<Claim, 'note' | 'transportPrice' | 'goodsPrice' | 'totalServicePrice'> & {
    transportPrice: number | null;
    goodsPrice: number | null;
    totalServicePrice: number | null;
};

const toV21 = (claim: Claim): ClaimV21Response => {
    const { note, transportPrice, goodsPrice, totalServicePrice, ...rest } = claim;
    void note;

    return {
        ...rest,
        products: rest.products?.map((product) => ({
            ...product,
            claimedQuantity: asInt(product.claimedQuantity) ?? product.claimedQuantity,
            resendQuantity: asInt(product.resendQuantity) ?? null,
        })),
        transportPrice: toNumber(transportPrice),
        goodsPrice: toNumber(goodsPrice),
        totalServicePrice: toNumber(totalServicePrice),
    };
};

export class ClaimsMapperV21 {
    public static fromCore(coreClaim: ClaimedOrderResponse): ClaimV21Response {
        return toV21(ClaimsMapper.fromCore(coreClaim));
    }

    public static toCore(
        claim: Partial<Claim>,
        coreOrder?: CoreOrder,
        coreProducts: Pick<ProductInterface, 'SKU' | 'ID'>[] = []
    ): Partial<ReceivedClaimedOrderPayload> {
        return ClaimsMapper.toCore(claim, coreOrder, coreProducts);
    }

    public static fromCoreGrid(grid: CoreClaimsGridOutput): GridOutput {
        const result = ClaimsMapper.fromCoreGrid(grid);
        return {
            ...result,
            data: result.data.map((claim) => toV21(claim as Claim)),
        };
    }

    public static toCoreGrid(grid: GridInput): CoreGridInput {
        return ClaimsMapper.toCoreGrid(grid);
    }
}
